import * as React from 'react';
import {
    AdminContext,
    localStorageStore, defaultI18nProvider
} from 'react-admin';

import authProvider from './utils/authProvider';
import dataProvider from './utils/dataProvider';
import AsyncResources from './AsyncResources';

const store = localStorageStore();

const App = () => (
    <AdminContext
        dataProvider={dataProvider}
        authProvider={authProvider}
        i18nProvider={defaultI18nProvider}
        store={store}
    >
        <AsyncResources />
    </AdminContext>
)

authProvider.refreshTokens().catch();

export default App;
